export default function timeline() {
	const timelines = document.querySelectorAll('[data-name="timeline"]');
	if (!timelines.length) return;
    if ( window.innerWidth < 768 ) return; // Only run on desktop.

	timelines.forEach((timelineEl) => {
		const rows = Array.from(timelineEl.querySelectorAll('.timeline-row'));
		if (!rows.length) return;

		const pills = rows
			.map((row) => row.querySelector('.sticky > div'))
			.filter(Boolean);

		pills.forEach((pill) => {
			pill.style.transition = 'opacity 10ms linear';
			pill.style.willChange = 'opacity';
		});

		let ticking = false;
		let lastActiveIndex = -1;

		const getStickyTop = () => {
			const stickyEl = rows[0]?.querySelector('.sticky');
			if (!stickyEl) return 0;

			const computedTop = window.getComputedStyle(stickyEl).top;
			const top = parseFloat(computedTop);
			return Number.isFinite(top) ? top : 0;
		};

		const update = () => {
			ticking = false;
			const stickyTop = getStickyTop();

			let activeIndex = -1;
			for (let i = 0; i < rows.length; i++) {
				const top = rows[i].getBoundingClientRect().top;
				if (top <= stickyTop) activeIndex = i;
				else break;
			}

			if (activeIndex === lastActiveIndex) return;
			lastActiveIndex = activeIndex;

			for (let i = 0; i < pills.length; i++) {
				const pill = pills[i];
				if (!pill) continue;
				const hidden = activeIndex >= 0 && i < activeIndex;
				pill.style.opacity = hidden ? '0' : '1';
				pill.style.pointerEvents = hidden ? 'none' : '';
			}
		};

		const onScroll = () => {
			if (ticking) return;
			ticking = true;
			window.requestAnimationFrame(update);
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);
		update();
	});
}
